
import { defineComponent, onMounted, ref, computed } from 'vue'
import { useStore } from '@/store/index'
import { useI18n } from 'vue-i18n'
import LayoutsAuth from '@/layouts/Auth.vue'
import { toArray } from '@/utils/array'
import BasePagination from '@/components/BasePagination.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuth, BasePagination, LayoutsAuthWidth },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const seminars = computed(() => store.state.seminar.seminars)
    const pageSize = ref(5)
    const pagedList = ref([])

    onMounted(() => {
      store.dispatch('seminar/fetchSeminars')
    })

    const isOpen = (openAt: string) => (new Date(openAt) < new Date())
    const isClosed = (closedAt: string) => (new Date(closedAt) < new Date())

    return {
      t,
      seminars,
      isOpen,
      isClosed,
      toArray,
      pageSize,
      pagedList
    }
  },
})
